<script lang="ts">
	import ImageBox from './_ImageBox.svelte';
	import TextContentBox from './_TextContentBox.svelte';
	import type { PublicListingEvent } from '$lib/vivenu/types';

	export let event: PublicListingEvent;
	export let hover = false;
	export let hideMeta = false;
	export let deemphasise = false;
</script>

<div class:hover>
	<ImageBox {event} {hideMeta} {deemphasise} />
	<TextContentBox {hideMeta} {event} />
</div>

<style>
	div {
		text-decoration: none !important;
		transition: all 0.2s ease-in-out;
		box-shadow: 0 0 12px rgba(0, 0, 0, 16%);

		display: flex;
		flex-direction: column;
		overflow: hidden;
		height: 100%;

		color: #222;
		text-decoration: none !important;
		word-wrap: break-word;

		border: 1px solid #e5e5e5;
		border-radius: 6px;
	}

	.hover:hover {
		transform: scale(101%);
		box-shadow: 0 0 24px rgba(0, 0, 0, 8%);
	}
</style>
